/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { FormattedMessage, defineMessages } from "react-intl";

import { fetchVirtualSportsGamesToken } from "actions/games/creators";
import { getVirtualSportsGamesURL } from "../../../../config/games";
import { balance as getBalanceAction } from "actions/balance/balanceAction";

import vbl from "./assets/vbl.png";
import vfac from "./assets/vfac.png";
import vfcc from "./assets/vfcc.png";
import vfc from "./assets/vfc.png";
import vfl from "./assets/vfl.png";
import vfwc from "./assets/vfwc.png";

import {BackIcon} from "../slots/SlotsNav.jsx";
import { isAvailableGames } from "../../../../shared/utils/functions";

const messages = defineMessages({
  games_sport_vfl: {
    id: "games.sport_vfl",
    defaultMessage: "Футбольная лига",
  },
  games_sport_vfcc: {
    id: "games.sport_vfcc",
    defaultMessage: "Футбол Кубок чемпионов",
  },
  games_sport_vfwc: {
    id: "games.sport_vfwc",
    defaultMessage: "Футбол Чемпионат Мира",
  },
  games_sport_vfc: {
    id: "games.sport_vfc",
    defaultMessage: "Футбол Еврокубок 2020",
  },
  games_sport_vfac: {
    id: "games.sport_vfac",
    defaultMessage: "Футбол Кубок Азии",
  },
  games_sport_vbl: {
    id: "games.sport_vbl",
    defaultMessage: "Баскетбольная лига",
  },
  games_back_to_games: {
    id: "games.back_to_games",
    defaultMessage: "Назад к списку игр",
  },
});

const LIST = [
  {
    name: messages.games_sport_vfl,
    img: vfl,
    link: "vflm",
  },
  {
    name: messages.games_sport_vfcc,
    img: vfcc,
    link: "vfcc",
  },
  {
    name: messages.games_sport_vfwc,
    img: vfwc,
    link: "vfwc",
  },
  {
    name: messages.games_sport_vfc,
    img: vfc,
    link: "vfc",
  },
  {
    name: messages.games_sport_vfac,
    img: vfac,
    link: "vfas",
  },
  {
    name: messages.games_sport_vbl,
    img: vbl,
    link: "vbl",
  },
];

class VirtualSports extends Component {
  static contextTypes = {
    footer: React.PropTypes.object,
  };

  state = {};

  componentWillMount() {
    const { user, countryCode } = this.props;
    const gamblerId = user ? user.get("gamblerId") : null;
    const resourceId = user ? user.get("resourceId") : null;

    if (user && isAvailableGames(countryCode, resourceId, gamblerId)) {
      this.props.fetchVirtualSportsGamesToken(user.toJS());
    }

    if (window.addEventListener) {
      window.addEventListener("message", this.listener, false);
    } else {
      window.attachEvent("onmessage", this.listener);
    }
  }

  componentWillUnmount = () => {
    window.removeEventListener("message", this.listener);
  };

  listener = ({ data: json }) => {
    const { type, data } = typeof json === "string" ? JSON.parse(json) : {};
    switch (type) {
      case "rgs-height-change":
        return this.setState({
          height: data.height,
        });
      case "rgs-betslip-place":
        this.props.getBalanceAction({
          accountId: this.props.user.get("accountId"),
        });
        break;
      default:
        break;
    }
  };

  componentWillReceiveProps = (nextProps) => {
    const { user, countryCode } = this.props;
    const gamblerId = user ? user.get("gamblerId") : null;
    const resourceId = user ? user.get("resourceId") : null;

    if (
      user !== nextProps.user &&
      nextProps.user &&
      isAvailableGames(countryCode, resourceId, gamblerId)
    ) {
      this.props.fetchVirtualSportsGamesToken(nextProps.user.toJS());
    }
  }

  render() {
    const {
      virtual: { token },
      languageId,
      user,
    } = this.props;
    const { gameType, height } = this.state;
    const lang = languageId === 5 ? "en" : "ru";
    const gamblerId = user ? user.get("accountNum") : null;

    if (gameType) {
      return (
        <div>
          <div
            onClick={() => this.setState({ gameType: null })}
            className="virtual--back"
          >
            <BackIcon />
            <FormattedMessage {...messages.games_back_to_games} />
          </div>
          <div className="virtual_iframe">
            <iframe
              src={getVirtualSportsGamesURL({
                gameType,
                token,
                lang,
                gamblerId,
              })}
              frameBorder="0"
              scrolling="no"
              height={height + "px"}
            ></iframe>
          </div>

          {this.context.footer}
        </div>
      );
    }

    return (
      <div>
        <div className="games">
          {LIST.map((item) => (
            <a
              onClick={() => this.setState({ gameType: item.link })}
              className="games__card"
              key={item.link}
            >
              <div
                className="games__card--image"
                style={{
                  backgroundImage: `url(${item.img})`,
                }}
              />
              <div className="games__card--title">
                <FormattedMessage {...item.name} />
              </div>
            </a>
          ))}
        </div>

        {this.context.footer}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.auth.get("user"),
    countryCode: state.application.get("countryCode"),
    languageId: state.application.get("languageId"),
    virtual: state.games.virtual,
  };
};

export default connect(mapStateToProps, {
  fetchVirtualSportsGamesToken,
  getBalanceAction,
  push,
})(VirtualSports);



// WEBPACK FOOTER //
// ./js/sport-betting/components/games/virtual-sports/index.js